import { SiteCreateState } from "@/Administration/Components/Sites/SiteCreate";
import { AdministrationHelper } from "@/Administration/Helpers/AdministrationHelper";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { LocalizedTextDto } from "@/Common/Models/LocalizedTextDto";

interface IClinicWebsiteSubSectionProps {
    localizedWebsite: LocalizedTextDto;
    mutateState: (mutation: (state: SiteCreateState) => void, then?: () => void) => void;
}

function ClinicWebsiteSubSection(props: IClinicWebsiteSubSectionProps): JSX.Element {
    const { getText } = useTranslation();
    const { localizedWebsite, mutateState } = props;

    const onChangeHandle = (value: string, propertyName: string): void => {
        mutateState(state => state.localizedWebsite = {
            ...localizedWebsite,
            [propertyName]: value
        });
    };

    return (
        <>
            <div className="view-subsection-header row">
                <div className="col-lg-4 col-md-2 col-sm-2 text-right">
                    <h4 className="view-subsection-title">{getText("ClinicInfo_ClinicWebsiteLabel")}</h4>
                </div>
            </div>

            <div className="view-subsection-body">
                {AdministrationHelper.getLocalizedTextSiteCreateArray(localizedWebsite).map((item, index) => (
                    <div key={`website_${index}`} className="row" style={{ marginBottom: "15px" }}>
                        <div className="col-lg-4 col-md-3 col-sm-12 vcenter text-right">
                            <label className="form-label">URL ({item.languageName})</label>
                        </div>
                        <div className="col-lg-5 col-md-9 col-sm-12">
                            <TextboxControl
                                valid={ValidationHelper.validateUrl(item.value)}
                                debounceMs={200}
                                maxLength={AdministrationHelper.maxNoteLengthLimit}
                                className="form-control"
                                onChange={value => {
                                    if (value.length > AdministrationHelper.maxNoteLengthLimit) {
                                        return;
                                    }
                                    onChangeHandle(value, item.propertyName);
                                }}
                                value={item.value}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export { IClinicWebsiteSubSectionProps };
export default ClinicWebsiteSubSection;
